export const SMS_DISCLOSURE_VERSION = 'v1-2026-09';

export const SMS_DISCLOSURE_TEXT =
  'By checking this box, I agree to receive text messages from Evolution Electric regarding my service inquiries, appointment confirmations, reminders, and follow-ups. Message frequency varies. Message and data rates may apply. Reply STOP to opt out or HELP for assistance. Consent is not required to purchase services. See our Privacy Policy and Terms of Service.';
